import './styles.scoped.css'
import {useState} from 'react'
import {Typography, IconButton, Collapse, Skeleton} from '@mui/material'
import {ExpandMore, ExpandLess} from '@mui/icons-material'
import {SkeletonContainer, TextSkeleton} from '../../../../components'

const TrackSkeleton = () => (
    <SkeletonContainer>
        <div className="track-container">
            <div className="track">
                <Skeleton variant="rounded" height={14} sx={{position: 'absolute', left: '22%', width: '48%', top: 0, borderRadius: '8px'}} />
                <Skeleton variant="rounded" height={14} sx={{position: 'absolute', left: '26%', width: '44%', top: 20, borderRadius: '8px'}} />
            </div>
        </div>
        <div className="ticks">
            {Array.from({length: 6}).map((_, index) => (
                <TextSkeleton key={index} width={32} fontSize={12} />
            ))}
        </div>
    </SkeletonContainer>
)

export default ({visitWindow, skeleton = false}) => {
    const [expanded, setExpanded] = useState(true)

    return (
        <div className="card">
            <div className="header" onClick={() => setExpanded(prev => !prev)}>
                <Typography variant="h8" color="text.primary">
                    VISIT WINDOW
                </Typography>
                <IconButton size="small">{expanded ? <ExpandLess /> : <ExpandMore />}</IconButton>
            </div>
            <Collapse in={expanded}>
                <br />
                <div className="legend">
                    <div className="legend-item">
                        <div className="dot" style={{backgroundColor: '#BDBDBD'}} />
                        <Typography variant="body2" color="text.secondary">
                            Scheduled
                        </Typography>
                    </div>
                    <div className="legend-item">
                        <div className="dot" style={{backgroundColor: '#2E7D32'}} />
                        <Typography variant="body2" color="text.secondary">
                            Actual (on target)
                        </Typography>
                    </div>
                    <div className="legend-item">
                        <div className="dot" style={{backgroundColor: '#ED6C02'}} />
                        <Typography variant="body2" color="text.secondary">
                            Actual (flagged)
                        </Typography>
                    </div>
                </div>
                <br />
                {skeleton && <TrackSkeleton />}
                {!skeleton && (
                    <>
                        <div className="track-container">
                            <div className="track">
                                <div
                                    className="bar"
                                    style={{
                                        left: `${visitWindow?.scheduled_start}%`,
                                        width: `${visitWindow?.scheduled_end - visitWindow?.scheduled_start}%`,
                                        top: 0,
                                        backgroundColor: '#BDBDBD',
                                    }}
                                />
                                <div
                                    className="bar"
                                    style={{
                                        left: `${visitWindow?.actual_start}%`,
                                        width: `${visitWindow?.actual_end - visitWindow?.actual_start}%`,
                                        top: 20,
                                        backgroundColor: visitWindow?.flagged ? '#ED6C02' : '#2E7D32',
                                    }}
                                />
                            </div>
                        </div>
                        <div className="ticks">
                            {visitWindow?.ticks?.map(tick => (
                                <Typography variant="caption" color="text.secondary" key={tick}>
                                    {tick}
                                </Typography>
                            ))}
                        </div>
                    </>
                )}
            </Collapse>
        </div>
    )
}
